import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon, CheckIcon, ArrowRightIcon } from 'lucide-react';
import { getPopupOpen, setPopupOpen, subscribe } from '../utils/checkoutStore';
export function BundleUpsellPopup() {
  const [isOpen, setIsOpen] = useState(getPopupOpen());
  useEffect(() => {
    const unsubscribe = subscribe(() => {
      setIsOpen(getPopupOpen());
    });
    return unsubscribe;
  }, []);
  // Lock body scroll when open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);
  if (!isOpen) return null;
  const handleClose = () => {
    setPopupOpen(false);
  };
  const bundleUrl = 'https://homemasterglobal.com/cart/43635060408398:1';
  const mainProductUrl = 'https://homemasterglobal.com/cart/43531718492238:1';
  const originalPrice = 22.39;
  const bundlePrice = 12.36;
  const savings = originalPrice - bundlePrice;
  const discountPct = Math.round(savings / originalPrice * 100);
  return <AnimatePresence data-id="element-33">
      {isOpen && <div className="fixed inset-0 z-[100] flex items-center justify-center px-3 py-4" data-id="element-34">
          {/* Backdrop */}
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} onClick={handleClose} className="absolute inset-0 bg-black/60" data-id="element-35" />

          {/* Popup */}
          <motion.div initial={{
        opacity: 0,
        scale: 0.92,
        y: 24
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.92,
        y: 24
      }} transition={{
        duration: 0.3,
        ease: [0.16, 1, 0.3, 1]
      }} className="relative w-full max-w-[420px] bg-white rounded-2xl shadow-2xl overflow-hidden flex flex-col max-h-[92vh]" data-id="element-36">
            {/* Top green bar */}
            <div className="bg-[#07c86e] py-2 px-4 flex items-center justify-center gap-2" data-id="element-37">
              <motion.span animate={{
            opacity: [1, 0.4, 1]
          }} transition={{
            duration: 1.5,
            repeat: Infinity
          }} className="w-2 h-2 rounded-full bg-white" data-id="element-38" />
              <span className="text-white font-bold uppercase tracking-wider text-[14px]" data-id="element-39">
                Oferta Única — Solo Ahora
              </span>
            </div>

            {/* Close button */}
            <button onClick={handleClose} className="absolute top-2 right-3 z-10 w-7 h-7 flex items-center justify-center rounded-full bg-white/80 hover:bg-white transition-colors shadow-sm" data-id="element-40">
              <XIcon className="w-4 h-4 text-gray-600" data-id="element-41" />
            </button>

            {/* Scrollable content */}
            <div className="overflow-y-auto px-5 pt-5 pb-5" data-id="element-42">
              {/* Title */}
              <div className="text-center mb-4" data-id="element-43">
                <h2 className="text-2xl font-bold text-[#1A1614] mb-1" data-id="element-44">
                  ¡ESPERA! 🛑
                </h2>
                <p className="text-sm text-[#5a5248]" data-id="element-45">
                  Tenemos algo especial para ti
                </p>
              </div>

              {/* Discount badge */}
              <div className="mb-4" data-id="element-46">
                <p className="text-lg font-bold text-[#e76f51]" data-id="element-47">
                  {discountPct}% OFF — Paquete Completo
                </p>
              </div>

              {/* Description */}
              <p className="text-sm text-[#5a5248] mb-2 leading-relaxed" data-id="element-48">
                Te recomendamos este paquete para que no te falte nada y tengas
                todo lo necesario para crear tus Cinnamons Rolls XL.
              </p>
              <p className="text-xs mb-4 leading-relaxed font-[700] text-[#303030]" data-id="element-49">
                👉 Incluye los 2 extras que elevan todo desde el inicio.
              </p>

              {/* What's included box */}
              <div className="border-2 border-dashed border-[#e76f51]/30 rounded-xl p-4 mb-5" data-id="element-50">
                <p className="text-sm font-bold text-[#1A1614] mb-3" data-id="element-51">
                  🎁 Tu paquete completo incluye:
                </p>
                <div className="space-y-2.5" data-id="element-52">
                  {['Cinnamon Rolls XL (Método completo)', '3 Bonos Premium GRATIS', 'Salsas & Cremas Gourmet', 'Menú Rotativo Rolls XL'].map((item, i) => <div key={i} className="flex items-start gap-2.5" data-id="element-53">
                      <div className="w-5 h-5 rounded-full bg-[#07c86e]/10 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-54">
                        <CheckIcon className="w-3 h-3 text-[#07c86e]" data-id="element-55" />
                      </div>
                      <span className="text-sm text-[#1A1614] font-medium leading-snug" data-id="element-56">
                        {item}
                      </span>
                    </div>)}
                </div>
              </div>

              {/* Price block */}
              <div className="text-center mb-5" data-id="element-57">
                <div className="flex items-center justify-center gap-3 mb-1" data-id="element-58">
                  <span className="text-lg line-through text-[#a8a29e]" data-id="element-59">
                    ${originalPrice.toFixed(2)}
                  </span>
                  <span className="text-4xl font-bold text-[#e76f51]" data-id="element-60">
                    ${bundlePrice.toFixed(2)}
                  </span>
                </div>
                <p className="text-xs text-[#5a5248]" data-id="element-61">
                  Precio especial solo en esta pantalla
                </p>
              </div>

              {/* CTA */}
              <a href={bundleUrl} target="_blank" rel="noopener noreferrer" onClick={() => setPopupOpen(false)} className="w-full flex items-center justify-center gap-2 font-bold text-base py-3.5 px-6 rounded-full transition-all duration-300 no-underline mb-3" style={{
            backgroundColor: '#07c86e',
            color: '#ffffff',
            boxShadow: '0 4px 16px rgba(7,200,110,0.35)'
          }} onMouseEnter={e => {
            e.currentTarget.style.backgroundColor = '#06b061';
            e.currentTarget.style.transform = 'scale(1.02)';
          }} onMouseLeave={e => {
            e.currentTarget.style.backgroundColor = '#07c86e';
            e.currentTarget.style.transform = 'scale(1)';
          }} data-id="element-62">
                ¡Sí! Quiero el Paquete Completo
                <ArrowRightIcon className="w-5 h-5" data-id="element-63" />
              </a>

              {/* Decline */}
              <a href={mainProductUrl} target="_blank" rel="noopener noreferrer" onClick={() => setPopupOpen(false)} className="w-full flex items-center justify-center py-2 no-underline hover:text-[#5a5248] transition-colors text-[14px] font-[600] text-[#2E2E2E]" data-id="element-64">
                No gracias, continuar sin los extras →
              </a>
            </div>
          </motion.div>
        </div>}
    </AnimatePresence>;
}